module.exports = __webpack_public_path__ + "static/media/logo-default.ac2f97cd.png";